export default "__VITE_ASSET__BnpDoR3F__"